var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2020_215468)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 18V23C26.5 24.3807 25.3807 25.5 24 25.5C22.6193 25.5 21.5 24.3807 21.5 23V18C21.5 16.6193 22.6193 15.5 24 15.5C25.3807 15.5 26.5 16.6193 26.5 18ZM19.5 18C19.5 15.5147 21.5147 13.5 24 13.5C26.4853 13.5 28.5 15.5147 28.5 18V23C28.5 25.4853 26.4853 27.5 24 27.5C21.5147 27.5 19.5 25.4853 19.5 23V18ZM18 22.5C18 21.9477 17.5523 21.5 17 21.5C16.4477 21.5 16 21.9477 16 22.5C16 24.4007 16.4857 26.5104 17.7558 28.1702C18.9016 29.6675 20.6295 30.7221 23 30.9526V33H20.5C19.9477 33 19.5 33.4477 19.5 34C19.5 34.5523 19.9477 35 20.5 35H27.5C28.0523 35 28.5 34.5523 28.5 34C28.5 33.4477 28.0523 33 27.5 33H25V30.9526C27.3705 30.7221 29.0984 29.6675 30.2442 28.1702C31.5143 26.5104 32 24.4007 32 22.5C32 21.9477 31.5523 21.5 31 21.5C30.4477 21.5 30 21.9477 30 22.5C30 24.0993 29.5857 25.7396 28.6558 26.9548C27.757 28.1294 26.3088 29 24 29C21.6912 29 20.243 28.1294 19.3442 26.9548C18.4143 25.7396 18 24.0993 18 22.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2020_215468"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVoice);
export default __webpack_public_path__ + "static/media/ic_voice.15cb9651413e13bd008fe96565718d50.svg";
export { ForwardRef as ReactComponent };